import { EditSubcatagoryComponent } from './modules/subcatagory/edit-subcatagory/edit-subcatagory.component';
import { AddSubcatagoryComponent } from './modules/subcatagory/add-subcatagory/add-subcatagory.component';
import { SubcatagoriesComponent } from './modules/subcatagory/subcatagories/subcatagories.component';
import { ChangeProfilePasswordComponent } from './modules/change-profile-password/change-profile-password.component';
import { UserProfileComponent } from './modules/user-profile/user-profile.component';
import { EditBannerComponent } from './modules/Banner/edit-banner/edit-banner.component';
import { AddBannerComponent } from './modules/Banner/add-banner/add-banner.component';
import { BannersComponent } from './modules/Banner/banners/banners.component';
import { ContactUsComponent } from './modules/contact-us/contact-us.component';
import { ManageContentComponent } from './modules/manage-content/manage-content.component';
import { EditVoucherComponent } from './modules/voucher/edit-voucher/edit-voucher.component';
import { AddVoucherComponent } from './modules/voucher/add-voucher/add-voucher.component';
import { VouchersComponent } from './modules/voucher/vouchers/vouchers.component';
import { EditCatagoryComponent } from './modules/catagory/edit-catagory/edit-catagory.component';
import { AddCatagoryComponent } from './modules/catagory/add-catagory/add-catagory.component';
import { CatagoryListComponent } from './modules/catagory/catagory-list/catagory-list.component';
import { EditDishComponent } from './modules/edit-dish/edit-dish.component';
import { AddDishComponent } from './modules/add-dish/add-dish.component';
import { DishManagerComponent } from './modules/dish-manager/dish-manager.component';
import { RestaurantMenuComponent } from './modules/restaurant-menu/restaurant-menu.component';
import { EditRestaurantComponent } from './modules/edit-restaurant/edit-restaurant.component';
import { AddRestaurantComponent } from './modules/add-restaurant/add-restaurant.component';
import { RestaurantManagerComponent } from './modules/restaurant-manager/restaurant-manager.component';
import { EditDeliveryPartnerComponent } from './modules/edit-delivery-partner/edit-delivery-partner.component';
import { AddDeliveryPartnerComponent } from './modules/add-delivery-partner/add-delivery-partner.component';
import { DeliveryPartnerComponent } from './modules/delivery-partner/delivery-partner.component';
import { EditOfferComponent } from './modules/edit-offer/edit-offer.component';
import { AddOfferComponent } from './modules/add-offer/add-offer.component';
import { OfferManagerComponent } from './modules/offer-manager/offer-manager.component';
import { EditUserComponent } from './modules/edit-user/edit-user.component';
import { ViewProfileComponent } from './modules/view-profile/view-profile.component';
import { OrderDetailComponent } from './modules/order-detail/order-detail.component';
import { OrderManagerComponent } from './modules/order-manager/order-manager.component';
import { AddMemberComponent } from './modules/add-member/add-member.component';
import { AuthGuard } from './auth.guard';
import { ChangePasswordComponent } from './LoginPages/change-password/change-password.component';
import { OtpComponent } from './LoginPages/otp/otp.component';
import { ForgetPasswordComponent } from './LoginPages/forget-password/forget-password.component';
import { MemberlistComponent } from './modules/memberlist/memberlist.component';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { DefaultComponent } from './layouts/default/default.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './LoginPages/login/login.component';
import { ResetPasswordComponent } from './LoginPages/reset-password/reset-password.component';


const routes: Routes = [
  {
    path:'dashboard',
    component:DefaultComponent,
    children:[{
      canActivate:[AuthGuard],
      path:'',
      component:DashboardComponent},
      {
        path:'member',
        component:MemberlistComponent
      },
      {
        path:'add',
        component:AddMemberComponent
      },
      {
        path:'orders',
        component:OrderManagerComponent
      },
      {
        path:'orderDetail/:id',
        component:OrderDetailComponent
      },
      {
        path:"viewProfile/:id",
        component:ViewProfileComponent
      },
      {
        path:"editUser/:id",
        component:EditUserComponent
      },
      {
        path:"offerManager",
        component:OfferManagerComponent
      },
      {
        path:"addOffer",
        component:AddOfferComponent
      },
      {
        path:"editOffer/:id",
        component:EditOfferComponent
      },
      {
        path:"deliveryList",
        component:DeliveryPartnerComponent
      },
      {
        path:"AddDeliveryPartner",
        component:AddDeliveryPartnerComponent
      },
      {
        path:'editDeliveryPartner/:id',
        component:EditDeliveryPartnerComponent
      },
      {
        path:'restaurantList',
        component:RestaurantManagerComponent,
      },
      {
        path:'addRestaurant',
        component:AddRestaurantComponent
      },
      {
        path:'editRestaurant/:id',
        component:EditRestaurantComponent
      },
      {
        path:"restaurantMenu",
        component:RestaurantMenuComponent
      },
      {
        path:'dishes',
        component:DishManagerComponent
      },
    {
      path:"addDish",
      component:AddDishComponent
    },
    {
      path:"editDish/:id",
      component:EditDishComponent
    },
    {path:'category',
    component:CatagoryListComponent
   },
   {path:'AddCategory',
   component:AddCatagoryComponent
  },
  {path:'EditCategory/:id',
  component:EditCatagoryComponent
 },
 {
   path:'voucherList',
   component:VouchersComponent
 },
 {
   path:'AddVoucher',
   component:AddVoucherComponent
 },
 {
   path:'EditVoucher/:id',
   component:EditVoucherComponent
 },
 {
   path:'manageContent',
   component:ManageContentComponent
 },
 {
   path:'contact',
   component:ContactUsComponent
 },
 {
   path:'Baners',
   component:BannersComponent
 },
 {
   path:'addBanner',
   component:AddBannerComponent
 },
 {
   path:'editBanner/:id',
   component:EditBannerComponent
 },
 {
   path:'Profile',
   component:UserProfileComponent
 },
 {
   path:'ChangeUserPassword',
   component:ChangeProfilePasswordComponent
 },
 {
  path:'SubCatagories',
  component:SubcatagoriesComponent
},
{
  path:'AddSubcatagory',
  component:AddSubcatagoryComponent
},
{
  path:'EditSubcatagory/:id',
  component:EditSubcatagoryComponent
},


 
  ]
  },
  {
    path:'',
    component:LoginComponent
  }
  ,
  {
      path:'login',
      component:LoginComponent
  },
  {
    path:'forgetPassword',
    component:ForgetPasswordComponent
  },
  {
    path:'forgetPassword/otp',
    component:OtpComponent
  },
  {
    path:'resetPassword',
    component:ResetPasswordComponent
  },
  {
    path:'changePassword',
    component:ChangePasswordComponent
  }
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
